export const AdminURL = {
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_USERS: '/admin/users',
    ADMIN_ALL_INVOICES: '/admin/invoices',
}
